import React, { useContext, useEffect, useState } from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import "../Pages/Style/billsinvoice.css";
import "../Pages/Style/dashboard.css";
import "../../App.css";
import LogoutCard from '../Components/Card/LogoutCard';
import Footer from '../Components/Footer/Footer';
import SideBar from '../Components/SideBar/SideBar';
import TextLinkExample from '../Components/NavBar/NavBar';
import { SidebarContext } from '../../context/SidebarContext';
import { formatIndianNumber } from '../../Constant/utils';
import { Link } from 'react-router-dom';
import { useClientDetailQuery } from '../../redux/API/FM/ClientDetailApi';
import { useCpDetailQuery } from '../../redux/API/FM/CPDetailApi';
import axios from 'axios';
import { fmbaseUrl } from '../../Constant/Matcher';

const FMClientDetails = () => {
const { isSiderbaropen } = useContext(SidebarContext);
const [showLogout, setShowLogout] = useState(false);
const [searchQuery, setSearchQuery] = useState("")
const userData = JSON.parse(localStorage.getItem("userData")); 
const userId = userData?.validateEmail[0]?._id;
const [data, setData] = useState([])
const {data: cpList} = useCpDetailQuery(userId)
const [isLoading, setIsLoading] = useState(true)


 useEffect(() => {
    const getData = () => {
      let base = `clientlist?fmid=${userId}`
      if(searchQuery) base = `clientlist?fmid=${userId}&cpid=${searchQuery}`
      axios.get(`${fmbaseUrl}${base}`).then((res) => {
        setData(res?.data)
        setIsLoading(false)
      })
    }
    getData()
  },[userId, searchQuery])


  return (
    <>
    <div className="App">
        <SideBar />
        <div className={!isSiderbaropen ? "pages" : "pages-change"}>
          <TextLinkExample setShowLogout={setShowLogout} />
          <div className=" BillsInvoice  min-vh-100 ">
          <div className="PortfolioReviewHeader mx-4 my-4 py-3 px-2 d-flex justify-content-between align-items-center">
            <h4 className='mb-0'>Client Details</h4>
           <select name="" id="" className='px-4 py-1' value={searchQuery}   onChange={(e) => setSearchQuery(e.target.value)} >
            <option value="">Select CP</option>
            {
            cpList &&  cpList?.cpdetail?.map((i) => (
              <option value={i?.cpinfo?._id} key={i?.cpinfo?._id}>{i?.cpinfo?.name}</option>
            ))
            }
           
           </select>
          </div>
          <div className="BillsInvoiceTable mx-4 overflow-y-hidden ">
              <MDBTable
                hover
                striped
                style={{
                  backgroundColor: "RGB(255 255 255)",
                  fontSize: "12px",
                }}
              >
                <MDBTableHead
                  style={{ backgroundColor: "#5A4344", color: "white" }}
                >
                  <tr>
                    <th scope="col">Client Name</th>
                    <th scope="col">Mobile No.</th>
                    <th scope="col">Email</th>
                    <th scope="col">Investment</th>
                    <th scope="col">Current Portfolio</th>
                    <th scope="col">Absolute Return</th>
                    <th scope="col">CAGR</th>
                    <th scope="col">View Detail</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {
                    data && data?.clientdetail?.map((i) => (

                      <tr key={i?._id}>
                        <td>{i?.clientinfo?.name}</td>
                        <td>{i?.clientinfo?.phone}</td>
                        <td>{i?.clientinfo?.email}</td>
                        <td>{formatIndianNumber(i?.investmentamount)}</td>
                        <td>{formatIndianNumber(i?.clientsummary[0]?.holdingvalue)}</td>
                        <td>{i?.investmentamount === null || i?.investmentamount === 0 ? 0 : Math.round(((i?.clientsummary[0]?.holdingvalue - i?.investmentamount) / i?.investmentamount) * 100)}
                          %</td>
                        <td>{i?.clientsummary[0]?.CAGR === null ? 0 : Math.round(i?.clientsummary[0]?.CAGR)}%</td>
                        <td><Link to={`/FM/client_details/${i?.clientinfo?._id}`}>view</Link></td>
                      </tr>
                       ))
                      }
                  
                </MDBTableBody>
              </MDBTable>
            </div>
          </div>
          <Footer/>
          </div>
          </div>
          {showLogout && <LogoutCard setShowLogout={setShowLogout} />}
    </>
  )
}

export default FMClientDetails